import { Col, Container, Row } from "reactstrap";
import { WorkTitle } from "../../../constants";
import { WorkContentData, WorkData } from "../../../data/demo/CarDemo1";
import { dynamicSvg, dynamicImage, Image } from "../../../utils";
import CommonHeader from "../common/CommonHeader";

const Work = () => {
  return (
    <section className="car-work-section section-b-space">
      <Container>
        <h2 className="text-center mb-1">Sell Your Car to Us</h2>
        <CommonHeader contentClass="text-black" title={WorkTitle} content={WorkContentData} headClass="title-style-2" animation />
        <Row className="g-lg-5 gy-4 align-items-start justify-content-center">
            {WorkData.map((item, index) => (
              <Col xs="6" lg="3" sm="6" key={index}>
                {item.svg && <Image src={dynamicSvg("car/svg-line.svg")} alt="svg-line" className="img-fluid top-wave d-none d-lg-block" />}
                <div className="work-box" data-aos="zoom-in" data-aos-duration={item.duration}>
                  <div className="work-icon"><Image src={dynamicImage(`${item.icon}`)} className="w-50" /></div>
                  <div className="work-content">
                    <p className="title">{item.title}</p>
                    <p className="description">{item.text}</p>
                  </div>
                </div>
                {item.svg && <Image src={dynamicSvg("car/svg-line.svg")} alt="svg-line" className="img-fluid bottom-wave d-none d-lg-block" />}
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
};

export default Work;
